import PrimaryCard from '@/components/Statistics/PrimaryCard';
import StatisticsSharedCards from '@/components/Statistics/StatisticsSharedCards';
import React from 'react';
import { getProjectDashboardData } from '@/services/projects';
import { BygrProjectDetails } from '@/types';
import { showModules } from '@/utils/util';
import { useAsyncState, useAsyncStateWithIsLoading } from '@/utils/hooks';
import theme from './ProjectDashboard.module.scss';
import { getProjectLicenseStatus } from '@/services/licenses';
import { startCase } from 'lodash-es';
import { CustomLink } from '@ygtechnologies/bygr-frontend-component-library';
import EmailTemplatesCard from '@/components/EmailTemplates/EmailTemplatesCard';

interface ProjectDashboardProps {
    project: BygrProjectDetails;
}

const ProjectDashboard: React.FC<ProjectDashboardProps> = ({ project }) => {
    const [data] = useAsyncStateWithIsLoading(() => getProjectDashboardData(project.id), [project.id], null);
    const [licenseStatus] = useAsyncState(() => getProjectLicenseStatus(project!.id), [project.id], null);

    return (
        <div className={theme.dashboardContainer}>
            <PrimaryCard title="Project" loading={!data}>
                {() => (
                    <>
                        <PrimaryCard.Row label="Buyers">{data!.numberOfBuyers}</PrimaryCard.Row>
                        <PrimaryCard.Row label="Units">
                            {data!.numberOfSoldUnits}/{data!.numberOfUnits} sold
                        </PrimaryCard.Row>
                        <PrimaryCard.Row label="Modules">{showModules(project.sellerModules)}</PrimaryCard.Row>
                        <PrimaryCard.Row label="Seller profile">
                            <CustomLink to={`/profiles/${project.sellerProfile.id}`}>
                                {project.sellerProfile.name}
                            </CustomLink>
                        </PrimaryCard.Row>
                    </>
                )}
            </PrimaryCard>

            <PrimaryCard loading={!licenseStatus} title="Licenses">
                {() => (
                    <>
                        {licenseStatus!.map((item) => (
                            <PrimaryCard.Row key={item.module} label={startCase(item.module)}>
                                <span className={item.exceededLimit ? theme.licenseExceeded : undefined}>
                                    {item.actualUnits} / {item.isUnlimited ? 'Unlimited' : item.allowedUnits} units
                                </span>
                            </PrimaryCard.Row>
                        ))}
                    </>
                )}
            </PrimaryCard>

            <EmailTemplatesCard projectId={project.id} />

            <StatisticsSharedCards projectIds={[project.id]} />
        </div>
    );
};

export default ProjectDashboard;
